import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

if (typeof window !== "undefined" && !window.global) {
  window.global = window;
}

createRoot(document.getElementById("root")).render(<App />);

